








































import { defineComponent, computed } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'
import JsonRteField from '~/components/global/cms/JsonRteField.vue'
import { PdpPage } from '@/modules/contentstack/types'
import { useProductStore } from '~/store/product'
import { RteNode } from '~/types/rte/rteTypes'

export default defineComponent({
  components: { JsonRteField },
  props: {
    productIncludesData: {
      type: Object,
      required: false,
      default: undefined,
    },
    customProductIncludes: {
      type: Object as () => PdpPage,
      required: false,
      default: undefined,
    },
  },
  setup(props) {
    const { currentProduct } = storeToRefs(useProductStore())

    const footnotes = computed(() => currentProduct.value?.data?.attributes?.kits?.footnotes?.footnote || [])

    const productIncludesNode = computed<RteNode | undefined>(
      () => props.customProductIncludes?.components?.at(0)?.pdp_product_inquiry?.content?.json
    )

    return { productIncludesNode, footnotes }
  },
})
